import React from 'react';
import {useTranslation} from "react-i18next";
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Link} from "react-router-dom";
import {I18nLng, lngCode, routeName} from "../utils/constants";

const Header = () => {
    const {t, i18n} = useTranslation();

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div>
            <Navbar bg="dark" variant={"dark"} expand="lg">
                <Container>

                    <Navbar.Brand href="#home">
                        <img
                            alt="logo"
                            src="/assets/images/logo256.png"
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                        />{' '}
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <Nav.Link as={Link} to={routeName.home}>{t('nav.home')}</Nav.Link>
                            <Nav.Link as={Link} to={routeName.privacy}>{t('nav.privacy')}</Nav.Link>
                            <Nav.Link as={Link} to={routeName.termsOfUse}>{t('nav.termsOfUse')}</Nav.Link>
                            <Nav.Link as={Link} to={routeName.deleteAccount}>{t('nav.deleteAccount')}</Nav.Link>
                            <NavDropdown title={I18nLng.get(i18n.resolvedLanguage ?? "")?.nativeName}
                                         id="navbarScrollingDropdown">
                                {Object.keys(lngCode).map((lng) => {
                                    if (lng === i18n.resolvedLanguage) return null;
                                    return (
                                        <NavDropdown.Item key={lng} onClick={() => changeLanguage(lng)}>
                                            {I18nLng.get(lng)?.nativeName}
                                        </NavDropdown.Item>
                                    )
                                })}
                            </NavDropdown>
                        </Nav>

                    </Navbar.Collapse>
                </Container>

            </Navbar>
        </div>

    );
};

export default Header;
